import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import UNSAFE_SetEnvRef from '@uie/set-env-ref';
import styled from 'styled-components';
import cuid from 'cuid';
import { calculateRem } from '@uie/javascript-style-helpers';
import AnchorIconBase from './AnchorIconBase';
import TooltipDialog from './TooltipDialog';
import AnchorIcon from '../utils/AnchorIcon';
import { IconData } from '@vds-core/icons';
import { BodyConfig, TypographyConfig } from '@vds-core/typography';
import { colors } from '@vds-core/theme';
import { withVDSManager } from '@vds-core/utilities';
var propTypes = {
  /**
   * @deprecated renderAnchorElement
   */
  anchorElement: PropTypes.func,

  /**
   * String, React Component, or HTML to rendered as the body of the tooltip.
   */
  children: PropTypes.any,

  /**
   * @deprecated title
   */
  header: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),

  /**
   * @deprecated inverted
   */
  secondary: PropTypes.bool,

  /**
   * Boolean used to invert icon element color. Can only be used with base icon element
   */
  inverted: PropTypes.bool,

  /**
   * Size of icon
   */
  size: PropTypes.string,

  /**
   * @deprecated
   */
  offset: PropTypes.number,

  /**
   * @deprecated
   */
  type: PropTypes.string,

  /**
   * String, React Component, or HTML to rendered as the header of the tooltip.
   */
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.node]),

  /**
   * A String label that is required for accessibility, the should be very terse description ot the tooltips content.
   */
  ariaLabel: PropTypes.string,

  /**
   * Function that returns an HTML element or React component to be used as a custom anchor for the tooltip. The function is called with a React ref, and an object that will pass back aria-describedby, aria-expanded, and aria-label that has to be passed to the returned anchor element/component.
   */
  renderAnchorElement: PropTypes.func,

  /**
   *@ignore
   *Icon package used to render info icon as anchor
   */
  iconConfig: PropTypes.object,

  /**
   *@ignore
   *Enables focus state with dashed lines
   */
  focusState: PropTypes.bool,

  /**
   *@ignore
   *Enables hover state with medium weight icon
   */
  hoverState: PropTypes.bool,

  /**
   *@ignore
   *Enables grey medium weight icon on active
   */
  activeState: PropTypes.bool,

  /**
   *@ignore
   *configuration for body component
   */
  bodyConfig: PropTypes.object,

  /**
   *@ignore
   *configuration for body component
   */
  colorConfig: PropTypes.object,

  /**
   *
   *@ignore// typescale for body config
   */
  typescale: PropTypes.string,

  /**
   *
   *@ignore// padding for inside of dialog
   */
  dialogPadding: PropTypes.string,

  /**
   * Allows a unique ID to be passed to the component.
   */
  id: PropTypes.string,

  /**
   * Boolean that activates disabled state
   */
  disabled: PropTypes.bool,

  /**
   * Allows a unique component ID to be passed to the component as a reference for positioning other than the window object.
   */
  containerId: PropTypes.string
};
var defaultProps = {
  anchorElement: null,
  header: null,
  secondary: false,
  inverted: false,
  size: 'large',
  offset: 0,
  //added after renaming
  type: null,
  title: null,
  ariaLabel: 'More information',
  renderAnchorElement: null,
  iconConfig: IconData,
  focusState: false,
  hoverState: false,
  activeState: false,
  bodyConfig: BodyConfig,
  typescale: TypographyConfig.getTypescale(),
  dialogPadding: calculateRem(12, 0, 16, 12),
  colorConfig: colors,
  disabled: false
};
var TooltipWrapper = /*#__PURE__*/styled.span.withConfig({
  displayName: "TooltipWrapper",
  componentId: "sc-8y4bkd-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  position: relative;\n  padding: 0;\n  outline: none;\n  ", ";\n"])), function (_ref) {
  var disabled = _ref.disabled;
  return disabled && "\n    pointer-events: none;\n    cursor: default;\n  ";
});
var TooltipIconWrapper = /*#__PURE__*/styled.span.withConfig({
  displayName: "TooltipIconWrapper",
  componentId: "sc-8y4bkd-1"
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  outline: none;\n  z-index: ", ";\n"])), function (_ref2) {
  var clicked = _ref2.clicked,
      showDialog = _ref2.showDialog,
      hovered = _ref2.hovered;
  return clicked || hovered || showDialog ? 2 : 0;
});
var CustomAnchorElementWrapper = /*#__PURE__*/styled.span.withConfig({
  displayName: "CustomAnchorElementWrapper",
  componentId: "sc-8y4bkd-2"
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: inline-block;\n  position: relative;\n  z-index: ", ";\n"])), function (_ref3) {
  var clicked = _ref3.clicked,
      showDialog = _ref3.showDialog,
      hovered = _ref3.hovered;
  return clicked || hovered || showDialog ? 2 : 0;
});
var HitArea = /*#__PURE__*/styled.span.withConfig({
  displayName: "HitArea",
  componentId: "sc-8y4bkd-3"
})(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  transform: translate(-50%, -50%);\n  text-align: center;\n  cursor: pointer;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  bottom: 50%;\n  height: ", ";\n  width: ", ";\n  z-index: 1;\n  outline: none;\n"])), calculateRem(44), calculateRem(44));
var ScreenReaderText = /*#__PURE__*/styled.span.withConfig({
  displayName: "ScreenReaderText",
  componentId: "sc-8y4bkd-4"
})(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  whitespace: nowrap;\n  border: 0;\n"])));

function _checkIfIe() {
  var ua = window.navigator.userAgent;
  var ie10 = ua.indexOf('MSIE ');
  var ie11 = ua.indexOf('Trident/');

  if (ie10 > 0) {
    return true;
  } else if (ie11 > 0) {
    return true;
  }

  return false;
}

var Tooltip = /*#__PURE__*/function (_Component) {
  _inherits(Tooltip, _Component);

  var _super = _createSuper(Tooltip);

  function Tooltip() {
    var _this;

    _classCallCheck(this, Tooltip);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      hovered: false,
      keyboardFocused: false,
      showDialog: false,
      clicked: false,
      active: false,
      customAnchorPresent: false,
      isIe: _checkIfIe(),
      scrollPosition: null,
      tooltipAnchorCoordinates: {},
      hasScrollableContent: undefined
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this.setAnchorElementPositionProperties();

      document.addEventListener('click', _this._onClickOutside);
      window.addEventListener('scroll', _this.setAnchorElementPositionProperties);
      window.addEventListener('resize', _this.setAnchorElementPositionProperties); // this check is to see if a custom element is being used as an anchor
      // this flag will activate different styles for the dialog based on the boolean

      if (_this.props.anchorElement || _this.props.renderAnchorElement) {
        _this.setState({
          customAnchorPresent: true
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (prevProps, prevState) {
      if (prevState.showDialog !== _this.state.showDialog && _this.state.keyboardFocused) {
        if (!_this.state.showDialog) _this.setState({
          hasScrollableContent: undefined
        });
        document.getElementById(_this.tooltipId).focus();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      document.removeEventListener('click', _this._onClickOutside);
      window.removeEventListener('scroll', _this.setAnchorElementPositionProperties);
      window.removeEventListener('resize', _this.setAnchorElementPositionProperties);
    });

    _defineProperty(_assertThisInitialized(_this), "setAnchorElementPositionProperties", function () {
      // get the reference to the current tooltipAnchor
      var tooltipAnchor = _this.toolTipAnchorRef;
      var tooltipAnchorRef = tooltipAnchor;
      var tooltipAnchorCoordinates = tooltipAnchorRef.getBoundingClientRect(); // assign tooltipAnchorCoordinates the value of the current anchor ref boundingClientRect

      _this.setState({
        tooltipAnchorCoordinates: tooltipAnchorCoordinates
      });
    });

    _defineProperty(_assertThisInitialized(_this), "openDialog", function () {
      return _this.setState({
        showDialog: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "closeDialog", function () {
      _this.setState({
        showDialog: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setHasScrollableContent", function (value) {
      _this.setState({
        hasScrollableContent: value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeyDown", function (e, focused) {
      var _this$state = _this.state,
          showDialog = _this$state.showDialog,
          keyboardFocused = _this$state.keyboardFocused;
      var key = e.keyCode;
      var spacebar = key === 32;
      var enter = key === 13;
      var esc = key === 27;
      var tab = key === 9;
      var shift = e.shiftKey;
      /* dont scroll page when pressing space */

      if (spacebar) e.preventDefault();
      /* This will toggle the dialog/focused state based on interaction */

      if (enter || spacebar || esc && showDialog) {
        _this.setState({
          showDialog: !showDialog
        });
      } else if ((shift && tab || tab) && showDialog) {
        _this.closeDialog();
      }

      if (_this.anchorWithRef !== null && _this.anchorElementProps.props.onKeyDown) {
        _this.anchorElementProps.props.onKeyDown(e);
      }

      if (_this.anchorWithRef !== null && _this.anchorElementProps.props.onBlur) {
        _this.anchorElementProps.props.onBlur(e);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "scrollbarId", cuid());

    _defineProperty(_assertThisInitialized(_this), "_onClickOutside", function (e) {
      // check if current event contains ref if not close dialog
      var toolTipAnchorRef = _this.toolTipAnchorRef;

      if (toolTipAnchorRef && !toolTipAnchorRef.contains(e.target) && e.target.parentNode.id !== "scrollbar-view-".concat(_this.scrollbarId) && e.target.id !== "scrollbar-view-".concat(_this.scrollbarId)) {
        _this.setState({
          scrollPosition: 0,
          keyboardFocused: false,
          clicked: false,
          showDialog: false,
          active: false,
          hovered: false
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseEnter", function (e) {
      if (e.target.parentNode.id !== "scrollbar-view-".concat(_this.scrollbarId)) {
        var keyboardFocused = _this.state.keyboardFocused;

        if (keyboardFocused) {
          _this.setState({
            keyboardFocused: false
          });
        }

        _this.openTooltipTimeout = setTimeout(function () {
          _this.setState({
            showDialog: true,
            hovered: true
          });
        }, 200);

        if (_this.anchorWithRef !== null && _this.anchorElementProps.props.onMouseEnter) {
          _this.anchorElementProps.props.onMouseEnter(e);
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseExit", function (e) {
      var _this$state2 = _this.state,
          clicked = _this$state2.clicked,
          showDialog = _this$state2.showDialog;

      if (clicked && showDialog) {
        return;
      } // clear time out to prevent showDialog being set to true unintentionally


      clearTimeout(_this.openTooltipTimeout);

      _this.setState({
        hovered: false,
        showDialog: false,
        keyboardFocused: false
      });

      if (_this.anchorWithRef !== null && _this.anchorElementProps.props.onMouseLeave) {
        _this.anchorElementProps.props.onMouseLeave(e);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_onClick", function (e) {
      var _this$state3 = _this.state,
          clicked = _this$state3.clicked,
          hovered = _this$state3.hovered,
          showDialog = _this$state3.showDialog;
      /* when using JAWS + keyboard interactions are handled by
      the onClick event. If this is the case, it wont be hovered, so show the dialog. */

      if (hovered) {
        clicked ? _this.setState({
          clicked: false,
          showDialog: false
        }) : _this.setState({
          clicked: true
        });
        return;
      } else if (e.target.id !== "scrollbar-view-".concat(_this.scrollbarId)) {
        _this.setState({
          clicked: false,
          showDialog: !showDialog
        });

        return;
      } else if (e.target.id === "scrollbar-view-".concat(_this.scrollbarId)) {
        _this.setState({
          clicked: false,
          showDialog: false
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseDown", function (e) {
      _this.setState({
        active: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseUp", function (e) {
      _this.setState({
        active: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_onFocus", function (e) {
      var _this$state4 = _this.state,
          hovered = _this$state4.hovered,
          keyboardFocused = _this$state4.keyboardFocused;
      /*  if the focus came from keyboard set it true, 
      if it came from mouse click, it will be set to false in _onClick */

      if (!hovered && !keyboardFocused) {
        _this.setState({
          keyboardFocused: true
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "setAnchorElement", function () {
      var _this$props = _this.props,
          anchorElement = _this$props.anchorElement,
          renderAnchorElement = _this$props.renderAnchorElement;
      var _this$state5 = _this.state,
          showDialog = _this$state5.showDialog,
          ariaLabel = _this$state5.ariaLabel;

      var computedProps = _objectSpread({
        ariaExpanded: showDialog,
        ariaLabel: ariaLabel
      }, _defineProperty({}, _this.refKey, function (elem) {
        return _this.toolTipAnchorRef = elem;
      }));

      if (anchorElement) {
        return anchorElement(computedProps);
      } else if (renderAnchorElement) {
        return renderAnchorElement(computedProps);
      }

      return null;
    });

    _defineProperty(_assertThisInitialized(_this), "_setScrollPosition", function (y) {
      _this.setState({
        scrollPosition: y
      });
    });

    _defineProperty(_assertThisInitialized(_this), "refKey", UNSAFE_SetEnvRef());

    _defineProperty(_assertThisInitialized(_this), "ariaId", "tooltip-".concat(cuid()));

    _defineProperty(_assertThisInitialized(_this), "tooltipId", cuid());

    _defineProperty(_assertThisInitialized(_this), "anchorWithRef", _this.setAnchorElement());

    _defineProperty(_assertThisInitialized(_this), "anchorElementProps", _this.anchorWithRef);

    _defineProperty(_assertThisInitialized(_this), "isAppleDevice", function () {
      return /iPhone/g.test(window.navigator.userAgent) || /iPad/g.test(window.navigator.userAgent);
    }());

    _defineProperty(_assertThisInitialized(_this), "isAndroidDevice", function () {
      return navigator.userAgent.toLowerCase().indexOf('android') > -1;
    }());

    _defineProperty(_assertThisInitialized(_this), "isFirefox", function () {
      return navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
    }());

    _defineProperty(_assertThisInitialized(_this), "_setDialogRef", function (elem) {
      _this.tooltipDialogRef = elem;

      if (elem && elem.offsetHeight - 1 > 202) {
        _this.setState({
          scrollable: true
        });
      } else {
        _this.setState({
          scrollable: false
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_dialogOnKeyDown", function (e, show) {
      // Close dialog and refocus anchor on esc space or enter key press
      if (e.keyCode === 13 || e.keyCode === 32 || e.keyCode === 27) {
        e.preventDefault();
        e.stopPropagation();

        _this.setState({
          showDialog: show
        });

        _this.toolTipAnchorRef.focus();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderTooltipDialog", function () {
      var _this$state6 = _this.state,
          scrollPosition = _this$state6.scrollPosition,
          clicked = _this$state6.clicked,
          customAnchorPresent = _this$state6.customAnchorPresent,
          isIe = _this$state6.isIe,
          tooltipAnchorCoordinates = _this$state6.tooltipAnchorCoordinates,
          showDialog = _this$state6.showDialog,
          keyboardFocused = _this$state6.keyboardFocused,
          hasScrollableContent = _this$state6.hasScrollableContent;
      var _this$props2 = _this.props,
          disabled = _this$props2.disabled,
          colorConfig = _this$props2.colorConfig,
          bodyConfig = _this$props2.bodyConfig,
          typescale = _this$props2.typescale,
          dialogPadding = _this$props2.dialogPadding,
          children = _this$props2.children,
          header = _this$props2.header,
          title = _this$props2.title,
          offset = _this$props2.offset,
          size = _this$props2.size,
          inverted = _this$props2.inverted,
          containerId = _this$props2.containerId;
      var hasAnchorElement = _this.props.anchorElement || _this.props.renderAnchorElement ? true : false;

      if (showDialog && !disabled) {
        return /*#__PURE__*/React.createElement(TooltipDialog, {
          scrollPosition: scrollPosition,
          setScrollPosition: _this._setScrollPosition,
          colorConfig: colorConfig,
          bodyConfig: bodyConfig,
          typescale: typescale,
          dialogPadding: dialogPadding,
          clicked: clicked,
          customAnchorElement: _this.toolTipAnchorRef,
          customAnchorPresent: customAnchorPresent,
          content: children,
          deactivateDialogState: _this.closeDialog,
          header: header,
          title: title,
          ariaId: _this.ariaId,
          keyboardFocused: keyboardFocused,
          keepDialogActiveOnMouseEnter: !keyboardFocused ? _this.openDialog : null,
          toolTipAnchorRef: _this.toolTipAnchorRef,
          showDialog: showDialog,
          offset: offset,
          size: size,
          inverted: inverted,
          isIe: isIe,
          containerId: containerId,
          tooltipAnchorCoordinates: tooltipAnchorCoordinates,
          isIOS: _this.isAppleDevice,
          onKeyDown: _this._dialogOnKeyDown,
          setRef: _this._setDialogRef,
          setHasScrollableContent: _this.setHasScrollableContent,
          hasScrollableContent: hasScrollableContent,
          hasAnchorElement: hasAnchorElement,
          isFirefox: _this.isFirefox,
          onTabKeyPress: _this.closeDialog,
          scrollbarId: _this.scrollbarId
        });
      }

      return null;
    });

    _defineProperty(_assertThisInitialized(_this), "renderIconAnchorElement", function () {
      var _this$props3 = _this.props,
          iconConfig = _this$props3.iconConfig,
          colorConfig = _this$props3.colorConfig,
          focusState = _this$props3.focusState,
          disabled = _this$props3.disabled,
          ariaLabel = _this$props3.ariaLabel,
          secondary = _this$props3.secondary,
          type = _this$props3.type,
          size = _this$props3.size,
          inverted = _this$props3.inverted,
          activeState = _this$props3.activeState,
          hoverState = _this$props3.hoverState;
      var _this$state7 = _this.state,
          clicked = _this$state7.clicked,
          showDialog = _this$state7.showDialog,
          hovered = _this$state7.hovered,
          isIe = _this$state7.isIe,
          keyboardFocused = _this$state7.keyboardFocused,
          active = _this$state7.active,
          hasScrollableContent = _this$state7.hasScrollableContent;
      return /*#__PURE__*/React.createElement(TooltipIconWrapper, {
        tabIndex: -1,
        importantForAccessibility: "no",
        clicked: clicked,
        showDialog: showDialog,
        hovered: hovered
      }, /*#__PURE__*/React.createElement(AnchorIconBase, _extends({
        tabIndex: 0,
        "data-testid": "tooltip",
        id: _this.tooltipId,
        colorConfig: colorConfig,
        focusState: focusState,
        "aria-expanded": hasScrollableContent === undefined ? false : hasScrollableContent && !_this.isFirefox && !isIe ? undefined : showDialog,
        "aria-label": isIe || _this.isAndroidDevice ? undefined : ariaLabel,
        hovered: hovered,
        clicked: clicked,
        onFocus: !disabled ? _this._onFocus : undefined,
        onMouseEnter: disabled ? undefined : _this._onMouseEnter,
        onMouseDown: disabled ? undefined : _this._onMouseDown,
        onMouseLeave: disabled ? undefined : _this._onMouseExit,
        onMouseUp: disabled ? undefined : _this._onMouseUp,
        onClick: disabled ? undefined : _this._onClick,
        type: type,
        showDialog: showDialog,
        size: size,
        inverted: inverted,
        keyboardFocused: keyboardFocused,
        disabled: disabled
      }, _defineProperty({}, _this.refKey, function (elem) {
        return _this.toolTipAnchorRef = elem;
      })), isIe || _this.isAndroidDevice && /*#__PURE__*/React.createElement(ScreenReaderText, null, ariaLabel), /*#__PURE__*/React.createElement(ScreenReaderText, {
        "aria-live": "assertive"
      }, hasScrollableContent && !isIe && "".concat(showDialog ? _this.isFirefox ? '' : 'expanded' : 'collapsed')), /*#__PURE__*/React.createElement("span", {
        tabIndex: -1,
        style: {
          outline: 'none',
          display: 'inline-flex'
        }
      }, /*#__PURE__*/React.createElement(AnchorIcon, {
        tabIndex: -1,
        colorConfig: colorConfig,
        iconConfig: iconConfig,
        disabled: disabled,
        onClick: _this._onclick,
        importantForAccessibility: "no",
        size: size,
        secondary: secondary,
        type: type,
        showDialog: showDialog,
        inverted: inverted,
        clicked: clicked,
        hovered: hovered,
        activeState: activeState,
        hoverState: hoverState,
        keyboardFocused: keyboardFocused,
        active: active,
        ariaLabel: ariaLabel
      }), !_this.props.disabled && /*#__PURE__*/React.createElement(HitArea, {
        tabIndex: -1,
        "aria-hidden": true,
        importantForAccessibility: "no",
        "data-testid": "hit-area"
      })), /*#__PURE__*/React.createElement("span", {
        // assertive is necessary for scrollable content with Jaws
        "aria-live": "assertive"
      }, _this.renderTooltipDialog())));
    });

    _defineProperty(_assertThisInitialized(_this), "renderCustomAnchorElement", function () {
      var anchorWithRef = _this.setAnchorElement();

      var _this$props4 = _this.props,
          disabled = _this$props4.disabled,
          ariaLabel = _this$props4.ariaLabel;
      var _this$state8 = _this.state,
          clicked = _this$state8.clicked,
          showDialog = _this$state8.showDialog,
          hovered = _this$state8.hovered,
          isIe = _this$state8.isIe,
          hasScrollableContent = _this$state8.hasScrollableContent;
      return /*#__PURE__*/React.createElement(CustomAnchorElementWrapper, _extends({}, _defineProperty({}, _this.refKey, function (elem) {
        return _this.toolTipAnchorRef = elem;
      }), {
        "aria-label": isIe ? undefined : ariaLabel,
        onMouseEnter: disabled ? undefined : _this._onMouseEnter,
        onMouseDown: disabled ? undefined : _this._onMouseDown,
        onMouseLeave: disabled ? undefined : _this._onMouseExit,
        onMouseUp: disabled ? undefined : _this._onMouseUp,
        onClick: disabled ? undefined : _this._onClick,
        onFocus: !disabled ? _this._onFocus : undefined,
        "aria-expanded": showDialog,
        clicked: clicked,
        showDialog: showDialog,
        hovered: hovered
      }), /*#__PURE__*/React.createElement(ScreenReaderText, {
        "aria-live": "assertive"
      }, hasScrollableContent && "".concat(showDialog ? _this.isFirefox || isIe ? '' : 'expanded' : 'collapsed')), /*#__PURE__*/React.createElement("div", {
        tabIndex: -1
      }, /*#__PURE__*/React.cloneElement(anchorWithRef, {
        onKeyDown: !disabled ? _this._onKeyDown : undefined,
        id: _this.tooltipId,
        'aria-expanded': showDialog
      })), /*#__PURE__*/React.createElement("span", {
        "aria-live": "assertive"
      }, _this.renderTooltipDialog()));
    });

    return _this;
  }

  _createClass(Tooltip, [{
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          id = _this$props5.id,
          className = _this$props5.className;
      return /*#__PURE__*/React.createElement(TooltipWrapper, {
        id: id,
        className: className,
        size: this.props.size,
        trailing: this.props.trailing,
        tabIndex: -1
      }, this.props.anchorElement || this.props.renderAnchorElement ? this.renderCustomAnchorElement() : this.renderIconAnchorElement());
    }
  }]);

  return Tooltip;
}(Component);

Tooltip.defaultProps = defaultProps;
Tooltip.propTypes = propTypes;
export default withVDSManager(Tooltip);